import { AccessTime, Check, Refresh } from '@mui/icons-material'
import { FC, ReactElement } from 'react'

import Box from '@mui/material/Box'
import { GRAY_300 } from 'constants/styling/theme'
import { OverviewGroup } from '../../helpers/conversationOverview'
import { useTranslation } from 'react-i18next'

type PillGroup = Exclude<OverviewGroup, OverviewGroup.OTHER>

interface Props {
  conversationId: string
  group: PillGroup
}

const PILL: Record<PillGroup, { background: string, color: string, labelKey: string, icon: ReactElement }> = {
  [OverviewGroup.REPLY_NEEDED]: { background: '#FFE8E2', color: '#A83519', labelKey: 'chat:overview.reply_needed', icon: <Refresh /> },
  [OverviewGroup.IN_PROGRESS]: { background: '#E3F2FD', color: '#1B5580', labelKey: 'chat:list_status.in_progress', icon: <AccessTime /> },
  [OverviewGroup.RESOLVED]: { background: GRAY_300, color: '#4A4E52', labelKey: 'chat:overview.resolved', icon: <Check /> },
}

export const OverviewStatusPill: FC<Props> = ({ conversationId, group }) => {
  const { t } = useTranslation(['chat'])
  const pill = PILL[group]

  return (
    <Box
      component="span"
      data-testid={`conversation-status-${conversationId}`}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.4rem',
        padding: '0.3rem 0.8rem',
        borderRadius: '0.4rem',
        backgroundColor: pill.background,
        color: pill.color,
        fontSize: '1.2rem',
        fontWeight: 600,
        lineHeight: 1.3,
        '& svg': { fontSize: '1.2rem' },
      }}
    >

      {pill.icon}

      {t(pill.labelKey)}

    </Box>
  )
}
